import { render, staticRenderFns } from "./init-new.vue?vue&type=template&id=4e5a72a8&scoped=true"
import script from "./init-new.vue?vue&type=script&lang=js"
export * from "./init-new.vue?vue&type=script&lang=js"
import style0 from "./init-new.vue?vue&type=style&index=0&id=4e5a72a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5a72a8",
  null
  
)

export default component.exports